<template>
  <div class="filters-box qb-margin-top qb-padding">
    <router-link to="/" style="font-size: 14px;text-decoration: underline;">HOME</router-link> 
    <router-link v-if="descricaoVoltar" :to="anterior" style="font-size: 14px;text-decoration: underline;"> / {{ descricaoVoltar }}</router-link> 
      <h3 class="">Filtrar por</h3>
      <h4 style="font-size: 14px;">Categorias</h4>
      <ul style="line-height: 1.4em; padding-left: 15px;">
        <vue-element-loading :active="!this.categoriasPronto"/>
        <li class="categoria" v-for="categoria in categorias" :key="categoria.id">
          <a href="#"  @click.prevent="openSection(categoria)">{{categoria.description}}</a>
         <!-- <ul>
           <li v-for="subCategoria in categoria.subMenu" :key="subCategoria.id">
            <a href="#"  @click.prevent="openSection(subCategoria)">{{subCategoria.description}}</a>
          </li>
          </ul> -->
        </li>
      </ul>
      
      <h4 style="font-size: 14px;">Marcas</h4>
      <ul style="line-height: 1.4em;">
        <vue-element-loading :active="!this.marcasPronto"/>
        <li v-for="marca in marcas"  :key="marca.brand"><input type="checkbox" :value="marca.brand"  v-model="checkedNames" @change="check()"> {{ marca.brand }}</li>
      </ul>

        <div v-for="espec in especificacao" :key="espec.title">
          <h4 style="font-size: 14px;">{{ espec.title }}</h4>
          <br v-if="espec.title == 'PESO' || espec.title == 'TAMANHO' || espec.title == 'VAZÃO'"/>
          <vue-range-slider v-if="espec.title == 'PESO'" v-model="peso" :min="min" :max="max" :bg-style="bgStyle" :tooltip-style="tooltipStyle" :process-style="processStyle" :formatter="formatter" :tooltip-merge="tooltipMerge" :enable-cross="enableCross" @drag-end="updateRange()"></vue-range-slider>
          <vue-range-slider v-if="espec.title == 'TAMANHO'" v-model="tamanho" :min="minTamanho" :max="maxTamanho" :bg-style="bgStyle" :tooltip-style="tooltipStyle" :process-style="processStyle" :formatter="formatterTamanho" :tooltip-merge="tooltipMerge" :enable-cross="enableCross" @drag-end="updateRange()"></vue-range-slider>
          <vue-range-slider v-if="espec.title == 'VAZÃO'" v-model="vazao" :min="minVazao" :max="maxVazao" :bg-style="bgStyle" :tooltip-style="tooltipStyle" :process-style="processStyle" :formatter="formatterVazao" :tooltip-merge="tooltipMerge" :enable-cross="enableCross" @drag-end="updateRange()"></vue-range-slider>
          <ul v-if="espec.title != 'PESO' && espec.title != 'TAMANHO' && espec.title != 'VAZÃO'" style="line-height: 1.4em;">
            <li  v-for="item in espec.specifications" :key="item"><input type="checkbox" :value="espec.title+'|'+item" v-model="checkEspec" @change="check()"> {{ item }} </li>        
          </ul>
        </div>
  </div>
</template>

<script>
import axios from 'axios';
import { baseApiUrl } from "@/global";
import VueElementLoading from 'vue-element-loading';

import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'

export default {
  components: {
    VueElementLoading,
    VueRangeSlider
  },
  data(){
    return{
      categorias: '',
      marcas: '',
      especificacao: '',
      checkedNames: [],
      checkEspec:[],
      marcasPronto: false,
      categoriasPronto: false,
      especificacaoPronto:false,
      anterior: '',
      descricaoVoltar: '',
      peso: [0, 1700],
      tamanho: [0, 2000],
      vazao: [0, 2000]
    }
  },
  methods:{
    parametrosURL(){
      return `?brands=${ this.$route.query.marcas ? this.$route.query.marcas: '' }&param=${ this.$route.query.params ? this.$route.query.params : '' }&IdCategory=${ this.$route.query.idCategoria ? this.$route.query.idCategoria : 0 }&news=${ this.$route.query.novidades ? true : false }&offers=${ this.$route.query.ofertas ? true : false }&specifications=${ this.$route.query.especificacao ? this.$route.query.especificacao : ''}`;
    },
    montaCategoriaFiltro(){
        var url = `${baseApiUrl}/category/filter/${ this.parametrosURL() }`;
        axios.get(url)
        .then(res => {
          this.categorias = res.data;
          this.categoriasPronto = true;
        })
    },
    montaMarcasFiltro(){
        var url = `${baseApiUrl}/products/brands/${ this.parametrosURL() }`;
        axios.get(url)
        .then(res => {
          this.marcas = res.data;
          this.marcasPronto = true;
        })
    },
    montaEspecificacoesFiltro(){
        var url = `${baseApiUrl}/products/Specifications/${ this.parametrosURL() }`;
        axios.get(url)
          .then(res => {
          this.especificacao = res.data;
          this.especificacaoPronto = true;
        })
    },
    updateRange(){
      this.$router.push({ name: 'lista', 
      query:{ 
        marcas: this.checkedNames, 
        params: this.$route.query.params, 
        pagina: 1,
        idCategoria: this.$route.query.idCategoria,
        ofertas: this.$route.query.ofertas,
        novidades: this.$route.query.novidades,
        especificacao: this.checkEspec,
        peso: this.peso[0]+'|'+this.peso[1],
        tamanho: this.tamanho[0]+'|'+this.tamanho[1],
        vazao: this.vazao[0]+'|'+this.vazao[1]
      }});
    },
    check(){
      if(this.checkedNames.length == 0 && !this.$route.query.params && !this.$route.query.idCategoria && !this.$route.query.ofertas && !this.$route.query.novidades){
        this.$router.push('/');
        return
      }
      this.$router.push({ name: 'lista', 
      query:{ 
        marcas: this.checkedNames, 
        params: this.$route.query.params, 
        pagina: 1,
        idCategoria: this.$route.query.idCategoria,
        ofertas: this.$route.query.ofertas,
        novidades: this.$route.query.novidades,
        especificacao: this.checkEspec,
        peso: this.peso[0]+'|'+this.peso[1],
        tamanho: this.tamanho[0]+'|'+this.tamanho[1],
        vazao: this.vazao[0]+'|'+this.vazao[1]
      }});
    },
    openSection(item) {
      if(item.id.length == 2){
        this.descricaoFinal = '';
        this.anterior = '?pagina=1&idCategoria=' + item.classificationId;
        this.descricaoVoltar = item.description;
        this.$router.push({ name: 'lista', 
        query:{ 
          marcas: this.$route.query.marcas, 
          params: this.$route.query.params, 
          pagina: 1,
          idCategoria: item.classificationId,
          ofertas: this.$route.query.ofertas,
          novidades: this.$route.query.novidades,
          especificacao: this.checkEspec,
          //range: this.value[0]+'|'+this.value[1]
        }})
      }else{
        this.descricaoFinal = item.description;
        this.$router.push({ name: 'lista', 
        query:{ 
          marcas: this.$route.query.marcas, 
          params: this.$route.query.params, 
          pagina: 1,
          idCategoria: item.classificationId,
          ofertas: this.$route.query.ofertas,
          novidades: this.$route.query.novidades,
          especificacao: this.checkEspec
        }})
      }
   }
  },
  watch:{
    '$route' (to/*, from*/){
      if(to.fullPath == '/'){
        this.descricaoVoltar = ''
        }
        if(to.name != 'lista' || !this.$route.query.marcas){
          this.checkedNames = [];
          // this.especificacao = [];
          this.checkEspec = [];
          this.peso = [0, 1700];
          this.tamanho = [0, 2000];
          this.vazao = [0, 2000];
        }
        this.categoriasPronto = false;
        this.marcasPronto = false;
        this.montaCategoriaFiltro();
        this.montaMarcasFiltro();
        this.montaEspecificacoesFiltro();
    }
  },
  mounted(){
    this.montaCategoriaFiltro();
    this.montaMarcasFiltro();
    //this.montaEspecificacoesFiltro();
  },
  created() {
    this.min = 0.0
    this.max = 1700
    this.minTamanho = 0.0
    this.maxTamanho = 2000
    this.minVazao = 0.0
    this.maxVazao = 2000
    this.step = 10
    this.enableCross = false
    this.tooltipMerge = false
    this.formatter = peso => `${peso}G`
    this.formatterTamanho = tamanho => `${tamanho}ML`
    this.formatterVazao = vazao => `${vazao}L/H`
    this.bgStyle = {
     backgroundColor: 'rgb(121, 149, 127)',
    }
    this.tooltipStyle = {
      backgroundColor: '#28a745',
      borderColor: '#28a745'
    }
    this.processStyle = {
      backgroundColor: '#28a745'
    }
  }
}
</script>

<style scoped>
.filters-box{
    background-color: #fff;
    width: 200px;
    float: left;
    border-right: 1px solid #ddd;
    min-height: 770px;
}
.filters-box h3{
    color: #767676; 
    font-weight: 400 !important;
}

.categoria{
  list-style: initial;
}

li{    
    list-style: none;
    font-size: 14px;
}

@media screen and  (max-width: 949px){
    .filters-box{
      display: none;
    }
}
</style>>

